export const LineArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="2"
      viewBox="0 0 59 2"
      fill="none"
    >
      <path d="M0 1L59 0.999997" stroke="#BFBFBF" />
    </svg>
  );
};
